import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Stack,
  Typography,
  IconButton,
  Divider,
  Avatar,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const MemberCreateConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  loading = false,
  data = {},
  groups = [],
}) => {
  const getMembershipTypeLabel = (type) => {
    const labels = {
      0: 'Devamlı Üye',
      1: 'Devamdan Muaf Üye',
      2: 'Aidattan Muaf Üye',
      3: 'Onursal Üye',
      4: 'İzinli Üye',
    };
    return labels[type] || 'Bilinmiyor';
  };

  const getGroupName = (id) => {
    if (!id) return 'Seçilmedi';
    const group = groups.find((g) => g.id === id);
    return group?.name || 'Seçilmedi';
  };

  const {
    FirstName = '',
    LastName = '',
    Email = '',
    PhoneNumber = '',
    JobTitle = '',
    Company = '',
    Sector = '',
    LogoCariCode = '',
    University = '',
    HighSchool = '',
    Address = '',
    groupId = '',
    reference = null,
    membershipType = 0,
    previewUrl = '',
    file = null,
  } = data;

  return (
    <Dialog open={open} onClose={() => !loading && onClose?.()} fullWidth maxWidth="sm">
      <DialogTitle
        sx={{
          fontSize: '18px',
          fontWeight: 500,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          pr: 3,
        }}
      >
        Üye Oluşturma Onayı
        <IconButton
          onClick={() => !loading && onClose?.()}
          size="small"
          disabled={loading}
          sx={{
            color: 'text.secondary',
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.04)',
            },
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ py: 2, px: 3 }}>
        <Typography variant="body2" sx={{ fontSize: '14px', color: '#666666', mb: 3 }}>
          Girilen bilgileri kontrol edin ve onaylayın:
        </Typography>

        <Stack spacing={2.5}>
          {/* Kişisel Bilgiler */}
          <Box>
            <Typography variant="body2" sx={{ fontSize: '13px', fontWeight: 600, color: '#444444', mb: 1.5 }}>
              Kişisel Bilgiler
            </Typography>
            <Stack spacing={1}>
              <Box>
                <Typography variant="body2" sx={{ fontSize: '12px', color: '#a3a3a3', mb: 0.5 }}>
                  Ad Soyad
                </Typography>
                <Typography variant="body2" sx={{ fontSize: '14px', color: '#444444', fontWeight: 500 }}>
                  {FirstName} {LastName}
                </Typography>
              </Box>
              <Box>
                <Typography variant="body2" sx={{ fontSize: '12px', color: '#a3a3a3', mb: 0.5 }}>
                  E-posta
                </Typography>
                <Typography variant="body2" sx={{ fontSize: '14px', color: '#444444', fontWeight: 500 }}>
                  {Email || '-'}
                </Typography>
              </Box>
              <Box>
                <Typography variant="body2" sx={{ fontSize: '12px', color: '#a3a3a3', mb: 0.5 }}>
                  Telefon
                </Typography>
                <Typography variant="body2" sx={{ fontSize: '14px', color: '#444444', fontWeight: 500 }}>
                  {PhoneNumber || '-'}
                </Typography>
              </Box>
              {JobTitle && (
                <Box>
                  <Typography variant="body2" sx={{ fontSize: '12px', color: '#a3a3a3', mb: 0.5 }}>
                    Ünvan
                  </Typography>
                  <Typography variant="body2" sx={{ fontSize: '14px', color: '#444444', fontWeight: 500 }}>
                    {JobTitle}
                  </Typography>
                </Box>
              )}
              {Company && (
                <Box>
                  <Typography variant="body2" sx={{ fontSize: '12px', color: '#a3a3a3', mb: 0.5 }}>
                    Şirket
                  </Typography>
                  <Typography variant="body2" sx={{ fontSize: '14px', color: '#444444', fontWeight: 500 }}>
                    {Company}
                  </Typography>
                </Box>
              )}
              {Sector && (
                <Box>
                  <Typography variant="body2" sx={{ fontSize: '12px', color: '#a3a3a3', mb: 0.5 }}>
                    Sektör
                  </Typography>
                  <Typography variant="body2" sx={{ fontSize: '14px', color: '#444444', fontWeight: 500 }}>
                    {Sector}
                  </Typography>
                </Box>
              )}
              {LogoCariCode && (
                <Box>
                  <Typography variant="body2" sx={{ fontSize: '12px', color: '#a3a3a3', mb: 0.5 }}>
                    Logo Cari Kod
                  </Typography>
                  <Typography variant="body2" sx={{ fontSize: '14px', color: '#444444', fontWeight: 500 }}>
                    {LogoCariCode}
                  </Typography>
                </Box>
              )}
              {Address && (
                <Box>
                  <Typography variant="body2" sx={{ fontSize: '12px', color: '#a3a3a3', mb: 0.5 }}>
                    Ev Adresi
                  </Typography>
                  <Typography variant="body2" sx={{ fontSize: '14px', color: '#444444', fontWeight: 500 }}>
                    {Address}
                  </Typography>
                </Box>
              )}
            </Stack>
          </Box>

          <Divider sx={{ borderColor: '#e6e6e6' }} />

          {/* Eğitim Bilgileri */}
          {(University || HighSchool) && (
            <>
              <Box>
                <Typography variant="body2" sx={{ fontSize: '13px', fontWeight: 600, color: '#444444', mb: 1.5 }}>
                  Eğitim Bilgileri
                </Typography>
                <Stack spacing={1}>
                  {University && (
                    <Box>
                      <Typography variant="body2" sx={{ fontSize: '12px', color: '#a3a3a3', mb: 0.5 }}>
                        Üniversite
                      </Typography>
                      <Typography variant="body2" sx={{ fontSize: '14px', color: '#444444', fontWeight: 500 }}>
                        {University}
                      </Typography>
                    </Box>
                  )}
                  {HighSchool && (
                    <Box>
                      <Typography variant="body2" sx={{ fontSize: '12px', color: '#a3a3a3', mb: 0.5 }}>
                        Lise
                      </Typography>
                      <Typography variant="body2" sx={{ fontSize: '14px', color: '#444444', fontWeight: 500 }}>
                        {HighSchool}
                      </Typography>
                    </Box>
                  )}
                </Stack>
              </Box>
              <Divider sx={{ borderColor: '#e6e6e6' }} />
            </>
          )}

          {/* Kulüp Bilgileri */}
          <Box>
            <Typography variant="body2" sx={{ fontSize: '13px', fontWeight: 600, color: '#444444', mb: 1.5 }}>
              Kulüp Bilgileri
            </Typography>
            <Stack spacing={1}>
              {reference && (
                <Box>
                  <Typography variant="body2" sx={{ fontSize: '12px', color: '#a3a3a3', mb: 0.5 }}>
                    Referans Üye
                  </Typography>
                  <Typography variant="body2" sx={{ fontSize: '14px', color: '#444444', fontWeight: 500 }}>
                    {reference.fullName}
                  </Typography>
                </Box>
              )}
              <Box>
                <Typography variant="body2" sx={{ fontSize: '12px', color: '#a3a3a3', mb: 0.5 }}>
                  Grup
                </Typography>
                <Typography variant="body2" sx={{ fontSize: '14px', color: '#444444', fontWeight: 500 }}>
                  {getGroupName(groupId)}
                </Typography>
              </Box>
              <Box>
                <Typography variant="body2" sx={{ fontSize: '12px', color: '#a3a3a3', mb: 0.5 }}>
                  Üyelik Tipi
                </Typography>
                <Typography variant="body2" sx={{ fontSize: '14px', color: '#444444', fontWeight: 500 }}>
                  {getMembershipTypeLabel(membershipType)}
                </Typography>
              </Box>
              {file && (
                <Box>
                  <Typography variant="body2" sx={{ fontSize: '12px', color: '#a3a3a3', mb: 0.5 }}>
                    Profil Fotoğrafı
                  </Typography>
                  {previewUrl && <Avatar src={previewUrl} sx={{ width: 56, height: 56, mt: 0.5 }} />}
                  {!previewUrl && (
                    <Typography variant="body2" sx={{ fontSize: '14px', color: '#444444', fontWeight: 500 }}>
                      {file.name}
                    </Typography>
                  )}
                </Box>
              )}
            </Stack>
          </Box>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ py: 2, px: 3 }}>
        <Button
          onClick={() => onClose?.()}
          disabled={loading}
          sx={{
            textTransform: 'none',
            fontSize: '13px',
            color: '#666666',
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.04)',
            },
          }}
        >
          İptal
        </Button>
        <Button
          onClick={() => onConfirm?.()}
          variant="contained"
          disabled={loading}
          sx={{
            borderRadius: '5px',
            textTransform: 'none',
            fontSize: '14px',
            backgroundColor: '#0E4D94',
            boxShadow: 'none',
            '&:hover': {
              backgroundColor: '#0a3d7a',
              boxShadow: 'none',
            },
          }}
        >
          {loading ? 'Oluşturuluyor...' : 'Onayla ve Oluştur'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MemberCreateConfirmDialog;
